import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { markEmployerAsRefundAccount, updateEmployerRefundAccountStatus } from "../redux/actions/employerActions";

const REFUND_STATUS = [
    "PENDING",
    "PROCESSED"
];

const RefundAccountStatusModal = ({ open, onClose, employerId, refundData }) => {
    const dispatch = useDispatch();

    const [newStatus, setNewStatus] = useState(refundData.status ? refundData.status : "PENDING");
    const [newRefundAmount, setNewRefundAmount] = useState(refundData.refundAmount);
    const [newNote, setNewNote] = useState(refundData.note);

    const handleSave = () => {
        if (refundData.status) {
            const aParams = {
                "status": newStatus,
                "note": newNote != refundData.note ? newNote : null,
                "refundAmount": newRefundAmount != refundData.refundAmount ? newRefundAmount : null
            }
            dispatch(updateEmployerRefundAccountStatus(employerId, aParams));
        } else {
            const aParams = {
                "status": newStatus,
                "note": newNote,
                "refundAmount": newRefundAmount
            }
            dispatch(markEmployerAsRefundAccount(employerId, aParams));
        }
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Refund Account Status</DialogTitle>

            <DialogContent dividers>

                {/* --- Add New Update Section --- */}
                <Box mt={1} sx={{ display: 'flex', flexDirection: 'row', columnGap: '12px', alignItems: 'center' }}>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Status</InputLabel>
                        <Select
                            label="Status"
                            value={newStatus}
                            onChange={(e) => setNewStatus(e.target.value)}
                        >
                            {REFUND_STATUS.map((status) => (
                                <MenuItem key={status} value={status}>
                                    {status}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="Refund Amount"
                        fullWidth
                        margin="normal"
                        value={newRefundAmount}
                        onChange={(e) => setNewRefundAmount(e.target.value)}
                    />

                    <TextField
                        label="Add Note"
                        multiline
                        // rows={3}
                        fullWidth
                        margin="normal"
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                    />
                </Box>

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Close</Button>
                <Button variant="contained" onClick={handleSave}>
                    {refundData.status ? "Update" : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RefundAccountStatusModal;
